import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class PlannerService {

	url: string = `${this.config.getConfig("apiEndpoint")}/planner`;

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	public getUnassigned(date: string) {
		return this.http.get<ApiResponse>(this.url + "/unassigned/" + date);
	}

	public getAssigned(type: string, date: string) {
		return this.http.get<ApiResponse>(this.url + "/assigned/" + type + "/" + date);
	}

	public getCancelled(date: string) {
		return this.http.get<ApiResponse>(this.url + "/cancelled/" + date);
	}

	public getDetail(id: number) {
		return this.http.get<ApiResponse>(this.url + "/" + id);
	}

	public getAvailable(type: string, id: number) {
		return this.http.get<ApiResponse>(this.url + "/available/" + type + "/" + id);
	}

	public saveService(body: SchedulerAssignPostData) {
		return this.http.put<ApiResponse>(this.url, body);
	}

	public deleteService(id: number) {
		return this.http.delete<ApiResponse>(this.url + "/" + id);
	}

}

export interface SchedulerAssignPostData {
	"tempoAnticipoTime": string;
	"tempoPosticipoTime": string;
	"pubblicaRitorno": boolean;
	"durataServizioTime": number;
	"prFineDisponibilitaTime": string;
	"prInizioDisponibilitaTime": string;
	"prInizioDisponibilitaData": string;
	"prFineDisponibilitaData": string;
	"veicolo": number;
	"id": number;
	"autista": number;
}

export interface SchedulerRequestPostData {
	"costo": number;
	"partners": Array<number>;
	"id": number;
}